export class ManagerInfo {
    constructor(public id: number, public name: string) {}

    static fromJson(json: any): ManagerInfo {
        return new ManagerInfo(json.id, json.name);
    }
}
